// @ts-nocheck
(() => {
  // The theme editor can re-inject this script; reuse the existing controller instead of doubling listeners
  if (window.utilityBarSlider) {
    window.utilityBarSlider.init();
    return;
  }

  const MOBILE_QUERY = '(max-width: 767px)';
  let instance = null;

  function createSlider(slider) {
    const allSlides = Array.from(slider.querySelectorAll('.utility-bar__slide'));
    const prevBtn = slider.querySelector('.utility-bar__slider-arrow--prev');
    const nextBtn = slider.querySelector('.utility-bar__slider-arrow--next');
    const mql = window.matchMedia(MOBILE_QUERY);
    const controller = new AbortController();
    const { signal } = controller;

    const enableAutoRotate = slider.dataset.autorotate === 'true';
    const autoRotateInterval = parseInt(slider.dataset.autorotateSpeed, 10) || 5000;

    let slides = [];
    let currentIndex = 0;
    let timer = null;

    // Rebuild the slide list for the current breakpoint (Trustpilot slide is mobile-only)
    // and make sure exactly one slide is active.
    function setup() {
      stopAutoRotate();

      const previous = slides[currentIndex] || allSlides.find((slide) => slide.classList.contains('is-active'));
      slides = allSlides.filter((slide) => mql.matches || !slide.hasAttribute('data-mobile-only'));
      currentIndex = Math.max(0, slides.indexOf(previous));

      allSlides.forEach((slide) => {
        slide.classList.add('is-instant');
        slide.classList.remove('is-prev');
        slide.classList.toggle('is-active', slide === slides[currentIndex]);
      });
      // Re-enable transitions once a frame has rendered the reset. A forced reflow here (offsetWidth) ran
      // during page parse and cost a full-document layout (~350ms on a throttled phone).
      requestAnimationFrame(() => {
        requestAnimationFrame(() => allSlides.forEach((slide) => slide.classList.remove('is-instant')));
      });

      const showArrows = slides.length > 1;
      if (prevBtn) prevBtn.style.display = showArrows ? '' : 'none';
      if (nextBtn) nextBtn.style.display = showArrows ? '' : 'none';

      startAutoRotate();
    }

    function goToSlide(index, direction = 'next') {
      if (slides.length <= 1) return;

      if (mql.matches) {
        // Horizontal: next enters from the right, previous from the left
        const outgoing = slides[currentIndex];
        currentIndex = (index + slides.length) % slides.length;
        const incoming = slides[currentIndex];

        incoming.classList.add('is-instant');
        incoming.classList.toggle('is-prev', direction === 'prev');
        incoming.offsetWidth; // commit the start position
        incoming.classList.remove('is-instant', 'is-prev');

        outgoing.classList.remove('is-active');
        outgoing.classList.toggle('is-prev', direction === 'next');
        incoming.classList.add('is-active');
        return;
      }

      slides.forEach((slide, i) => {
        slide.classList.remove('is-active', 'is-prev');
        if (i === currentIndex && direction === 'next') {
          slide.classList.add('is-prev');
        }
      });

      currentIndex = (index + slides.length) % slides.length;
      slides[currentIndex].classList.add('is-active');
    }

    function nextSlide() {
      goToSlide(currentIndex + 1, 'next');
    }

    function prevSlide() {
      goToSlide(currentIndex - 1, 'prev');
    }

    function startAutoRotate() {
      if (enableAutoRotate && !timer && slides.length > 1) {
        timer = setInterval(nextSlide, autoRotateInterval);
      }
    }

    function stopAutoRotate() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener(
        'click',
        () => {
          stopAutoRotate();
          prevSlide();
          startAutoRotate();
        },
        { signal }
      );
    }

    if (nextBtn) {
      nextBtn.addEventListener(
        'click',
        () => {
          stopAutoRotate();
          nextSlide();
          startAutoRotate();
        },
        { signal }
      );
    }

    slider.addEventListener('mouseenter', stopAutoRotate, { signal });
    slider.addEventListener('mouseleave', startAutoRotate, { signal });
    mql.addEventListener('change', setup, { signal });

    setup();

    return {
      element: slider,
      destroy() {
        stopAutoRotate();
        controller.abort();
      },
    };
  }

  function destroy() {
    if (instance) instance.destroy();
    instance = null;
  }

  function init() {
    destroy();
    const slider = document.getElementById('utility-bar-slider');
    if (slider) instance = createSlider(slider);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('#utility-bar-slider')) init();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (instance && event.target.contains(instance.element)) destroy();
  });

  window.utilityBarSlider = { init };

  // Run immediately if DOM is already parsed, or wait for interactive state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
